import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { ROUTE_UNLINKED_CALLS } from "../../constants/mirtapbx.constants";

const UnlinkedCallsPage = Loadable(
  lazy(() => import("./UnlinkedCalls/UnlinkedCallsPage")),
);

export const mirtapbxRoutes = [
  {
    path: ROUTE_UNLINKED_CALLS,
    exact: true,
    element: <UnlinkedCallsPage />,
  },
];
